import type { PropsWithChildren } from 'react'

import { cn } from '@mntn-dev/ui-utilities'

export const Buttons = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  return <div className={cn('flex gap-8', className)}>{children}</div>
}
